import React, { useEffect, useMemo, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { Button, TablePagination } from "@mui/material";
import { useDebounce, useQueryParams } from "../../../hooks";
import { getAllPlans } from "./Helper";


const UserRequest = () => {
    const context = useOutletContext();
    const navigate = useNavigate();
    const [plans, setPlans] = useState([]);
    const { getParam, setMultiParam } = useQueryParams();
    const currentPage = getParam("page");
    const currentLimit = getParam("pageSize");
    const [usersPage, setUsersPage] = useState(parseInt(currentPage) || 0);
    const [usersLimit, setUsersLimit] = useState(parseInt(currentLimit) || 10);
    const [usersTotal, setUsersTotal] = useState(0);
    const [search, setSearch] = useState('');
    const debounceSearch = useDebounce(search, 1000);

    const handleChangePage = (event, newPage) => {
        fetchData(newPage, usersLimit);
        setUsersPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setUsersLimit(parseInt(event.target.value, 10));
        setUsersPage(0);
        fetchData(0, parseInt(event.target.value, 10));
    };

    const fetchData = (page, limit) => {
        getAllPlans(page, limit, debounceSearch)
            .then((response) => {
                setPlans(response?.data?.data)
                setUsersTotal(response?.data?.meta?.total  || 0); // Make sure to set total count
            })
            .catch((err) => console.log(err));
    };

    useEffect(() => {
        context(["Custom Subscripton", "User Requests"]);
        fetchData(usersPage, usersLimit);
    }, [debounceSearch]);

    useEffect(() => {
        setMultiParam({ "page": usersPage, "pageSize": usersLimit });
    }, [usersPage, usersLimit])
    return (
        <div className="p-5 shadow-md bg-white">
            <div className="grid grid-cols-6 gap-2">
                <h3
                    className="col-span-5 text-lg uppercase tracking-wider font-bold"
                    style={{ color: "#2EBAA3" }}
                >
                    User Requests
                </h3>
                <input
                    type="text"
                    id="search"
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search"
                    className="px-3 py-1.5 mr-2 mb-2 form-control block w-full text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none"
                />
            </div>
            <br />
            <div className="overflow-x-auto w-full">
                <table className="w-full text-sm text-left text-gray-500">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                        <tr>
                            <th scope="col" className="py-3 px-4 w-12">Sr.</th>
                            <th scope="col" className="py-3 px-4">Name</th>
                            <th scope="col" className="py-3 px-4">Username</th>
                            <th scope="col" className="py-3 px-4">Email</th>
                            <th scope="col" className="py-3 px-4">Phone</th>
                            <th scope="col" className="py-3 px-4">Role</th>
                            <th scope="col" className="py-3 px-4">Requested Date</th>
                            <th scope="col" className="py-3 px-4">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {plans?.map((user, index) => (
                            <tr className="bg-white border-b" key={user.id}>
                                <th scope="row" className="py-4 px-4 font-medium text-gray-900 whitespace-nowrap">
                                    {index + 1}
                                </th>
                                <td className="py-4 px-4 whitespace-nowrap">
                                    {user.firstName + " " + user.lastName}
                                </td>
                                <td className="py-4 px-4 whitespace-nowrap">{user.username}</td>
                                <td className="py-4 px-4 whitespace-nowrap">{user.email}</td>
                                <td className="py-4 px-4 whitespace-nowrap">{user.countryCode ? `+${user.countryCode}` : ''}{user.phone}</td>
                                <td className="py-4 px-4 whitespace-nowrap">{user.role}</td>
                                <td className="py-4 px-4 whitespace-nowrap">
                                    {user.requested_at ? user.requested_at?.split("T")[0] : '-'}
                                </td>
                                <td className="py-4 px-4 whitespace-nowrap">
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        className="!text-xs"
                                        onClick={()=> navigate(`/custom-subscription?role=${user.role.toLowerCase()}&userId=${user.id}&name=${user.firstName + " " + user.lastName}&custom=true`)}
                                    >
                                        Create Plan
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <TablePagination
                component="div"
                count={usersTotal}
                page={usersPage}
                onPageChange={handleChangePage}
                rowsPerPage={usersLimit}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[2, 5, 10, 25, 50, 100]}
            />
        </div>
    )
}

export default UserRequest